// src/pages/roulette.tsx
import dynamic from 'next/dynamic';
const Game = dynamic(() => import('@/components/roulette-game-client'), { ssr: false });

export default function RoulettePage() {
  return <Game />;
}
